export default function Header() {

    const randomcolor = () => {
    const random = "0123456789ABCDEF";
        let color = "#"; 
        for (let i = 0; i < 6; i++) {
            color += random[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    return (
        <div style={{backgroundColor: randomcolor(), padding: "5px", textAlign: "center"}}>
            <h1>Portal o grach komputerowych</h1>
        </div>
    );
}